import { Utils } from './Utils.js';
import { InvariantExpression } from './expressions/index.js';
import { ContextExpression } from './expressions/context/ContextExpression.js';
import { OclParser } from './parser/OclParser.js';

type TypeReference = string;
type APIImpl = { [k: string]: Function };
type APIRegistryImpl = Map<TypeReference, APIImpl>;

export class OclExecutionContext {
  private evaluationResult: any = undefined;
  private failedInvariants: Array<InvariantExpression> = [];
  private registeredTypes: any;
  private registeredEnumerations: any;
  private targetTypeName: string;
  private evaluatedContexts: Array<ContextExpression> = [];
  private labelsToExecute = [];
  private staticRegistry: APIRegistryImpl = new Map<TypeReference, APIImpl>();

  constructor(private obj: any) {
    this.targetTypeName = Utils.getClassName(obj);
    this.registeredTypes = OclParser.registeredTypes;
  }

  addFailedInvariant(inv: InvariantExpression): void {
    this.failedInvariants.push(inv);
  }

  //@ts-ignore
  setObjectToEvaluate(obj): OclExecutionContext {
    this.obj = obj;

    return this;
  }

  getObjectToEvaluate(): any {
    return this.obj;
  }

  getRegisteredType(targetTypeName: string): any {
    return this.registeredTypes[targetTypeName];
  }

  setTargetTypeName(name: string): void {
    this.targetTypeName = name;
  }

  getTargetTypeName(): string {
    return this.targetTypeName;
  }

  //@ts-ignore
  registerTypes(types): void {
    this.registeredTypes = { ...this.registeredTypes, ...types };
  }

  //@ts-ignore
  setRegisteredEnumerations(enumerations): void {
    this.registeredEnumerations = { ...this.registeredEnumerations, ...enumerations };
  }

  //@ts-ignore
  getRegisteredEnumeration(key): Array<any> {
    return this.registeredEnumerations[key] || [];
  }

  getFailedInvariants(): Array<InvariantExpression> {
    return this.failedInvariants;
  }

  getLabelsToExecute(): Array<string> {
    return this.labelsToExecute;
  }

  getEvaluationResult(): boolean {
    return this.evaluationResult;
  }

  setEvaluationResult(evaluationResult: boolean): void {
    this.evaluationResult = evaluationResult;
  }

  addEvaluatedContext(context: ContextExpression): void {
    this.evaluatedContexts.push(context);
  }

  getEvaluatedContexts(): Array<ContextExpression> {
    return this.evaluatedContexts;
  }

  getStatic(source: string): any {
    return this.staticRegistry.has(source) ? this.staticRegistry.get(source) : {};
  }

  enrichStatic(typeName: string, key: string, value: any) {
    if (!this.staticRegistry.has(typeName)) {
      this.staticRegistry.set(typeName, {});
    }
    //@ts-ignore
    this.staticRegistry.get(typeName)[key] = value;
  }

  registerStatics(staticAPI: APIRegistryImpl) {
    this.staticRegistry = staticAPI;
  }
}
